import { Link } from '@remix-run/react';
import { useTranslation } from 'react-i18next';
import LanguagePicker from '#app/components/LanguagePicker.tsx';
import Logo from './logo';
import MobileMenu from './mobile-menu';

export default function Header() {
	const { t } = useTranslation();

	return (
		<header className="absolute z-30 w-full">
			<div className="mx-auto max-w-6xl px-4 sm:px-6">
				<div className="flex h-16 items-center justify-between md:h-20">
					{/* Site branding */}
					<div className="flex-1">
						<Logo />
					</div>

					{/* Desktop navigation */}
					<nav className="hidden md:flex md:grow">
						{/* Desktop menu links */}
						<ul className="flex grow flex-wrap items-center">
							<li>
								<Link
									className="mx-4 text-sm font-medium text-slate-300 transition duration-150 ease-in-out hover:text-white lg:mx-5"
									to="/about"
								>
									{t('header.menu1')}
								</Link>
							</li>
							<li>
								<Link
									className="mx-4 text-sm font-medium text-slate-300 transition duration-150 ease-in-out hover:text-white lg:mx-5"
									to="/roadmap"
								>
									{t('header.menu2')}
								</Link>
							</li>
							<li>
								<Link
									className="mx-4 text-sm font-medium text-slate-300 transition duration-150 ease-in-out hover:text-white lg:mx-5"
									to="/contact"
								>
									{t('header.menu3')}
								</Link>
							</li>
						</ul>
					</nav>

					<LanguagePicker />

					<MobileMenu />
				</div>
			</div>
		</header>
	);
}
